import { Component, Input } from "@angular/core";

@Component({
  selector: "evrideo-sound-icon",
  templateUrl: "./sound-icon.component.html",
  styleUrl: "./sound-icon.component.scss",
})
export class SoundIconComponent {
  @Input("muted") muted: boolean = false;

  @Input("strokeColor") strokeColor: string = "#2DBBFC";
  @Input("fillColor") fillColor: string = "#2DBBFC";
  public _offColor = "#757575";
}
